import { Wsm2023Prediction } from "./Wsm2023Prediction";

export class Wsm2026Prediction extends Wsm2023Prediction {}
